import { render, staticRenderFns } from "./QuestionPallet.vue?vue&type=template&id=4e187152&"
import script from "./QuestionPallet.vue?vue&type=script&lang=js&"
export * from "./QuestionPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports